import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/solid";
import cx from "classnames";
import List from "components/List";

export default function DetailQanun({ qanun }) {
  const classes = cx({
    "flex justify-between w-full px-4 py-2 text-sm font-medium text-left rounded-lg bg-cardFeaturesHover hover:bg-primary focus:outline-none focus-visible:ring group hover:text-white transition-all duration-300": true,
  });
  return (
    <div className="w-full px-4">
      <div className="w-full mx-auto space-y-5 bg-none rounded-2xl">
        {qanun?.map((item) =>
          item?.list_bab_qanun_obj.map((x) => (
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className={classes} key={x.uuid}>
                    <List cardPm list={x.nama} qanun />
                    <ChevronUpIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary group-hover:text-white`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="px-4 pt-4 pb-2 text-gray-800 text-md">
                    <h1 className="font-bold text-center text-black">
                      {x.bab}
                    </h1>
                    <h1 className="font-bold text-center text-black">
                      {x.judul}
                    </h1>
                    <div dangerouslySetInnerHTML={{ __html: x?.isi }} />
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))
        )}
      </div>
    </div>
  );
}
